module.exports = __webpack_public_path__ + "img/bed.e12eac32.svg";